import { ALL_ASSETS_LINK_ID } from '~/utils/navigation/constants';

export const shouldGetFacetsWithOrganizationId = (query) => {
  const isLandingPage = Object.keys(query).length === 0;
  const isAllAssets =
    !isLandingPage && (!query.show || query.show === ALL_ASSETS_LINK_ID);

  return !isAllAssets;
};
